import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-input-check',
  templateUrl: './input-check.component.html',
  styleUrls: ['./input-check.component.less']
})
export class InputCheckComponent extends Field {
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }
}
